import { render, staticRenderFns } from "./price-scheme.vue?vue&type=template&id=75a158da&scoped=true&"
import script from "./price-scheme.vue?vue&type=script&lang=js&"
export * from "./price-scheme.vue?vue&type=script&lang=js&"
import style0 from "./price-scheme.vue?vue&type=style&index=0&id=75a158da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a158da",
  null
  
)

export default component.exports